// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsVerificationStatusesEditTemplate_heading__MXqlY","buttonLink":"ReportingDetailsVerificationStatusesEditTemplate_buttonLink__W20cX"};